'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('kevaCandidate', {
      url: '/kevaCandidate',
      template: '<kctab></kctab>',
      authenticate: 'admin'
    });
}
